import { useCallback } from 'react';
import { useToastContext } from '@/layout/context/toast-context';
import { getCrmChatSockJsUrl } from '@/config/chat-ws';
import { BUILD_ENV } from '@/config/build-env';
function envFlagIsTrue(value) {
    return value === '1' || value.toLowerCase() === 'true';
}
/**
 * SockJS/STOMP connection for team chat.
 * Off by default — set `ENABLE_CRM_CHAT=1` and `ENABLE_STOMP_WS=1` in `.env` and rebuild.
 */
export const CRM_CHAT_ENABLED = envFlagIsTrue(BUILD_ENV.ENABLE_CRM_CHAT) && envFlagIsTrue(BUILD_ENV.ENABLE_STOMP_WS);
/** Full SockJS URL (absolute when not using dev proxy — see `getCrmChatSockJsUrl`). */
export const CRM_CHAT_SOCKJS_URL = getCrmChatSockJsUrl();
export const CRM_CHAT_DEBUG = BUILD_ENV.NODE_ENV === 'development';
/** Toast when a message arrives in a room that is not active (widget + full page). */
export function useCrmChatForeignRoomToast() {
    const { showToast } = useToastContext();
    return useCallback((detail) => {
        showToast({
            severity: 'info',
            summary: 'New message',
            detail: `${detail.fromUser} in ${detail.roomLabel}: ${detail.preview}`,
            life: 3500,
        });
    }, [showToast]);
}
